import { Component, effect, inject, input, linkedSignal, signal } from '@angular/core';
import { concatMap, of, tap } from 'rxjs';
import { camps } from '../../../../../models/models.generated';
import { CampSubcategory } from '../../../models/camp-subcategory.model';
import { CampImagesApiService } from '../../../services/camp-images-api.service';

@Component({
    selector: 'app-camp-category-section',
    standalone: false,
    templateUrl: './camp-category-section.component.html',
    styleUrl: './camp-category-section.component.scss',
})
export class CampCategorySectionComponent {
    private imageService = inject(CampImagesApiService);

    photoFromParentCategory = input<boolean | undefined>(undefined);
    parentFileName = input<string | undefined | null>(undefined);
    parentImgBase64 = input<string | undefined | null>(undefined);
    imgUrl = input<string | undefined | null>(undefined);

    name = input.required<string>();
    campCategoryId = input.required<string>();
    isParentCategory = input.required<boolean>();
    subcategories = input<CampSubcategory[]>();

    imgBase64 = signal<string | undefined | null>(undefined);
    buttonDisabled = signal<boolean>(false);
    photoFromParentCategoryInternal = linkedSignal<boolean | undefined>(() => {
        return this.photoFromParentCategory();
    });
    fileNameToDisplayInternal = linkedSignal<string | undefined>(() => {
        return this.parentFileName();
    });

    imageEffect = effect(() => {
        const isParentCategory = this.isParentCategory();
        const url = this.imgUrl();

        if (isParentCategory) {
            if (url) {
                this.fetchPhotoForCategory(url);
            } else {
                this.imgBase64.set(null);
            }

            return;
        }

        const photoFromParent = this.photoFromParentCategory();
        const parentImgBase64 = this.parentImgBase64();
        if (photoFromParent === undefined || parentImgBase64 === undefined || url === undefined) {
            return;
        }

        if (photoFromParent && parentImgBase64) {
            this.imgBase64.set(parentImgBase64);
            return;
        }

        if (url) {
            this.fetchPhotoForCategory(url);
        }
    });

    onFileSelected(event: Event): void {
        this.buttonDisabled.set(true);

        const input = event.target as HTMLInputElement;
        if (!input.files || input.files.length === 0) {
            return;
        }

        const campCategoryId: string = this.campCategoryId();
        const file: File = input.files[0];
        const formData = new FormData();
        formData.append('file', file);

        this.imageService
            .uploadCampCategoryPhoto(campCategoryId, formData)
            .pipe(
                // tap((x: string) => {
                //     // this.fileNameToDisplay.set(x);
                // }),
                concatMap(() => {
                    return this.imageService.getCampCategoriesPhotos([campCategoryId], 90, 60);
                }),
                concatMap((urls: camps.CampCategoryPhotoUrlModel[]) => {
                    const url: string | undefined = urls.find((x) => x.campCategoryId === campCategoryId)?.photoUrl;
                    return url ? this.imageService.getPhotoManagementPhoto(url) : of(undefined);
                }),
                tap((x) => {
                    if (x) {
                        this.imgBase64.set(x.content);
                        this.fileNameToDisplayInternal.set(x.filename);
                    }
                    this.buttonDisabled.set(false);
                    this.photoFromParentCategoryInternal.set(false);
                })
            )
            .subscribe();
    }

    onRemoveClicked(): void {
        this.buttonDisabled.set(true);

        const campCategoryId: string = this.campCategoryId();
        this.imageService.deleteCampCategoryPhoto(campCategoryId).subscribe(() => {
            // this.fileNameToDisplay.set(undefined);
            this.fileNameToDisplayInternal.set(undefined);
            this.buttonDisabled.set(false);
            const parentPhoto = this.parentImgBase64();
            this.imgBase64.set(parentPhoto);
            this.photoFromParentCategoryInternal.set(true);
        });
    }

    private fetchPhotoForCategory(url: string) {
        this.imageService.getPhotoManagementPhoto(url).subscribe((x) => {
            this.imgBase64.set(x.content);
            this.fileNameToDisplayInternal.set(x.filename);
        });
    }
}
